import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'I RISULTATI DELLA TUA RICERCA',
        description: 'Questo è il risultato della tua ricerca. Per ogni verifica vedi il libro, il titolo e il numero di esercizi presenti.',
        name: 'ZanichelliHomeworkCardContainerWithTutorial',
        tutorialName: 'verifica_risultati-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 35,
        yOffset: -35
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 5,
        yOffset: -30
    }
};
